module.exports = __webpack_public_path__ + "static/img/brees-2014-slide-3.889216d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2014-slide-3.jpg
// module id = BoFp
// module chunks = 1